import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { useSnackbarContext } from 'Context/SnackbarContext';
import React from 'react';
import {
  FDAlert, FDClickableText, FDIcon,
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { displayErrorMessageWithChecks } from 'Context/SnackbarContext/utils';
import { dispatchManualRoutingSubmit } from 'Hooks/useRefreshEvent';
import MessageDisplayBoxWithTruncation from 'Components/ComponentLibrary/Molecules/MessageDisplayBoxWithTruncation';
import { dataAttrs } from 'Helpers/Testing';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const { clearModalCollection } = useModalContext();
  const { displayErrorMessage } = useSnackbarContext();

  const [loading, setLoading] = React.useState(false);
  const [showInternalNote, setShowInternalNote] = React.useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      await resource.submit();
      dispatchManualRoutingSubmit();
      clearModalCollection();
    } catch (err) {
      displayErrorMessageWithChecks(err, displayErrorMessage, 'Failed to route message');
    } finally {
      setLoading(false);
    }
  };

  return (
    <FDStack direction={'column'} spacing={4} paddingX={6} paddingY={4} {...dataAttrs('manual-message-routing-modal')}>
      <FDStack direction={'row'} spacing={1} alignItems={'center'}>
        <FDIcon icon={resource.attr('icon')} />
        <MetaControlField attr={'title'} />
      </FDStack>
      <FDStack spacing={2} direction={'column'}>
        {
          resource.isTruthy('isMessageOld')
            ? <FDAlert title={resource.attr('messageOldAlertText')} status={'warning'} />
            : null
        }
        <MessageDisplayBoxWithTruncation messageContent={resource.attr('messageContent')} />
      </FDStack>
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField attr={'routingTargetDescription'} />
        <MetaControlField attr={'routingTarget'} />
        <MetaControlField attr={'isCritical'} />
      </FDStack>
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField attr={'newThreadSubjectDescription'} />
        <MetaControlField attr={'newThreadSubject'} />
      </FDStack>
      <FDStack direction={'column'} spacing={2}>
        {
          !showInternalNote ? (
            <FDClickableText
              appearance={'standalone'}
              label={resource.attr('internalNoteDescription')}
              onClick={() => setShowInternalNote(true)}
              {...dataAttrs('internal-note-description-clickable-text')}
            />)
            : (
              <>
                <MetaControlField attr={'internalNoteDescription'} />
                <MetaControlField attr={'internalNote'} />
              </>
            )
        }
      </FDStack>
      <FDStack justifyContent={'flex-end'}>
        <FDPrimaryActionButton
          loading={loading}
          label={resource.attr('submitLabel')}
          onClick={handleClick}
          {...dataAttrs('manual-message-routing-submit-button')}
        />
      </FDStack>
    </FDStack>
  );
};

Layout.defaultProps = {};

Layout.propTypes = {};

export default Layout;
